// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Rollbar from "../../../../node_modules/rescript-rollbar/lib/es6_global/src/Rollbar.bs.js";
import * as Caml_obj from "../../../../node_modules/rescript/lib/es6/caml_obj.js";
import * as Belt_Array from "../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as JsUtils$Showside from "./JsUtils.bs.js";
import * as Product$Showside from "../types/Product.bs.js";
import * as Caml_js_exceptions from "../../../../node_modules/rescript/lib/es6/caml_js_exceptions.js";
import * as RollbarInstance$Showside from "./RollbarInstance.bs.js";
function getVariantId(product) {
  var idParts = product.id.split("_");
  return Belt_Array.get(idParts, idParts.length - 1 | 0);
}
function prepareProduct(product) {
  var variantId = getVariantId(product);
  var newrecord = Caml_obj.obj_dup(product);
  newrecord.id = Belt_Option.getWithDefault(variantId, product.id);
  return newrecord;
}
function reportError(name, exn) {
  var messagePrefix = "Custom script \"" + name + "\" failed";
  var jsExn = Rollbar.$$Error.fromRescript(JsUtils$Showside.Exn.unwrapJsError(exn));
  var rootCause = Rollbar.$$Error.getRootCause(jsExn);
  var match = rootCause.message;
  var match$1 = rootCause.name;
  var rootCauseMessage = match !== undefined ? match$1 !== undefined ? "RC: " + match$1 + " " + match + "" : "RC: " + match + "" : match$1 !== undefined ? "RC: " + match$1 + "" : undefined;
  var message = Belt_Array.keepMap([messagePrefix, rootCauseMessage], function (a) {
    return a;
  }).join(", ");
  console.error(messagePrefix, jsExn);
  return RollbarInstance$Showside.critical3(Rollbar.$$Error.fromStringWithCause(message, jsExn), message, exn);
}
function triggerCustomFunction(code, product, variant, quantityOpt, name, linkerParam, param) {
  var quantity = quantityOpt !== undefined ? quantityOpt : 1;
  var variant$1 = Belt_Option.getWithDefault(variant, product.firstVariant);
  var legacyProduct = prepareProduct(Product$Showside.toLegacyDTO(product, variant$1));
  try {
    var func = new Function("product", "quantity", "product2", "variant2", "linkerParam", code);
    return Promise.resolve(func(legacyProduct, quantity, product, variant$1, linkerParam));
  } catch (raw_e) {
    var e = Caml_js_exceptions.internalToOCamlException(raw_e);
    return reportError(name, e).then(function (param) {
      return Promise.reject(e);
    });
  }
}
function triggerCustomFunctionReturningString(code, product, variant, name, linkerParam, param) {
  var variant$1 = Belt_Option.getWithDefault(variant, product.firstVariant);
  var legacyProduct = prepareProduct(Product$Showside.toLegacyDTO(product, variant$1));
  try {
    var func = new Function("product", "product2", "variant2", "linkerParam", code);
    return func(legacyProduct, product, variant$1, linkerParam);
  } catch (raw_e) {
    var e = Caml_js_exceptions.internalToOCamlException(raw_e);
    reportError(name, e);
    return;
  }
}
function triggerCustomFunctionWithoutProducts(code, name, linkerParam, param) {
  try {
    var func = new Function("linkerParam", code);
    return Promise.resolve(func(linkerParam));
  } catch (raw_e) {
    var e = Caml_js_exceptions.internalToOCamlException(raw_e);
    return reportError(name, e).then(function (param) {
      return Promise.reject(e);
    });
  }
}
export { getVariantId, prepareProduct, reportError, triggerCustomFunction, triggerCustomFunctionReturningString, triggerCustomFunctionWithoutProducts };
/* Rollbar Not a pure module */